/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmDailyTrxInfo } from './EvmDailyTrxInfo';

export type EvmHomeTotalClaimInfo = {
    TCCNT: string;
    CNGP: string;
    TRXHTP: EvmHomeTotalClaimInfo.TRXHTP;
    DTRXLIST: Array<EvmDailyTrxInfo>;
};

export namespace EvmHomeTotalClaimInfo {

    export enum TRXHTP {
        DAY = 'DAY',
        WEEK = 'WEEK',
        MONTH = 'MONTH',
        QUARTER = 'QUARTER',
    }


}

